import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './AppRoutes';
import GradientLayout from './components/GradientLayout';

const App = () => {
  return (
    <Router>
      <GradientLayout>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </GradientLayout>
    </Router>
  );
};

export default App;